// extracted by mini-css-extract-plugin
export var burgerContainer = "header-module--burger-container--38d4e";
export var container = "header-module--container--5cb9d";
export var link = "header-module--link--9aeae";
export var logo = "header-module--logo--9932e";
export var logoContainer = "header-module--logo-container--1daec";
export var title = "header-module--title--de67b";